var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0772 0L16.0023 2.92516L13.7724 5.15608L10.8472 2.23092L13.0772 0ZM2.36328 13.639H5.28844L12.3936 6.53383L9.46848 3.60867L2.36328 10.7139V13.639Z",
    fill: "#1B242C",
    fillOpacity: 0.74
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.304688 18C0.304688 16.8954 1.20012 16 2.30469 16H14.3047C15.4093 16 16.3047 16.8954 16.3047 18H0.304688Z",
    fill: "#535960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCategory);
export default __webpack_public_path__ + "static/media/editCategory.23be130284687fba88ccda7e7d12f04c.svg";
export { ForwardRef as ReactComponent };